import { render } from "./Alert.vue?vue&type=template&id=365676a2&scoped=true"
import script from "./Alert.vue?vue&type=script&setup=true&lang=js"
export * from "./Alert.vue?vue&type=script&setup=true&lang=js"

import "./Alert.vue?vue&type=style&index=0&id=365676a2&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-365676a2"],['__file',"src/components/Atoms/Alert.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "365676a2"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('365676a2', __exports__)) {
    api.reload('365676a2', __exports__)
  }
  
  module.hot.accept("./Alert.vue?vue&type=template&id=365676a2&scoped=true", () => {
    api.rerender('365676a2', render)
  })

}


export default __exports__